import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const DOCUMENTS = API_URL_VERSION + "documentos";
export const PARKING_CREDENTIALS = "credencial-estacionamento";
export const LIST = "listar";

export const DocumentType = {
    DISABLED: { value: "DEFICIENTE", labelKey: "disabled", display: "Deficiente" },
    ELDER: { value: "IDOSO", labelKey: "elder", display: "Idoso" },
};

export const MIN_ELDER_AGE = 60;

export const documentsParkingCredentialsService = {
    create: async (data, id) => {
        try {
            const response = await api.post(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${id}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.create";
        }
    },

    update: async (data, id) => {
        try {
            const response = await api.put(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${id}`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.update";
        }
    },


    list: async (parentID) => {
        try {
            const response = await api.get(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${parentID}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.list";
        }
    },

    listWithFilters: async (params = {}, parentId) => {
        try {
            const searchParams = toSearchFilter(params);
            const response = await api.post(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${LIST}/${parentId}`, searchParams);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "documents.messages.errors.list";
        }
    },

    find: async (parentID, id) => {
        try {
            const response = await api.get(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${parentID}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.find";
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`${DOCUMENTS}/${PARKING_CREDENTIALS}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "documents.messages.errors.delete";
        }
    },

};
